// "Who operates ConfirmPH, and how to reach them" — shown at the end of every
// policy page.
//
// Generated from the canonical operator record (see lib/operatorContacts):
// it names a registered entity only once one is recorded and verified, and a
// Data Protection Officer only once one has actually been appointed. Until
// then it says so, instead of printing a placeholder that implies otherwise.
import { useOperatorContacts } from "@/lib/operatorContacts";
import { useT } from "@/i18n/I18nProvider";

export default function OperatorNotice({ testId = "operator-notice" }) {
  const c = useOperatorContacts();
  const { lang } = useT();
  const tl = lang === "tl";
  return (
    <aside className="mt-10 rounded-xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-700"
           data-testid={testId}>
      <h2 className="font-display text-base font-semibold text-slate-900">
        {tl ? "Operator at contact" : "Operator and contacts"}
      </h2>
      <p className="mt-1" data-testid={`${testId}-operator`}>
        {tl ? "Ang ConfirmPH ay pinapatakbo ng" : "ConfirmPH is operated by"} {c.operatorName}.
      </p>
      {!c.legalEntityRecorded && c.disclosure && (
        <p className="mt-1 text-slate-600" data-testid={`${testId}-disclosure`}>{c.disclosure}</p>
      )}
      <dl className="mt-3 grid grid-cols-1 sm:grid-cols-[auto_1fr] gap-x-6 gap-y-1 text-xs">
        <dt className="text-slate-500">{tl ? "Support" : "Support"}</dt>
        <dd className="break-all">
          <a className="underline" href={`mailto:${c.support}`}>{c.support}</a>
        </dd>
        <dt className="text-slate-500">{tl ? "Privacy requests" : "Privacy requests"}</dt>
        <dd className="break-all" data-testid={`${testId}-privacy`}>
          <a className="underline" href={`mailto:${c.privacy}`}>{c.privacy}</a>
        </dd>
        <dt className="text-slate-500">{tl ? "Data Protection Officer" : "Data Protection Officer"}</dt>
        <dd data-testid={`${testId}-dpo`}>
          {c.dpoAppointed
            ? c.dpoName
            : (tl ? "Wala pang na-appoint. Ang privacy requests ay hinahawakan ng ConfirmPH team sa privacy contact sa itaas."
                  : "None appointed yet. Privacy requests are handled by the ConfirmPH team at the privacy contact above.")}
        </dd>
        <dt className="text-slate-500">{tl ? "Security issues" : "Security issues"}</dt>
        <dd className="break-all">
          <a className="underline" href="/security">{tl ? "Security contact" : "Security contact"}</a>
        </dd>
      </dl>
    </aside>
  );
}
